const CALCULATOR_INTERACTION_FLAG = "pwcCalculatorInteractionTracked";

const formatOut = (n) => (Number.isFinite(n) ? n.toFixed(1) : "-");

const maybePushCalculatorInteractionOnce = (rootEl, hasValidComputedResult) => {
    if (!rootEl || !hasValidComputedResult) {
        return;
    }
    if (
        typeof window !== "undefined" &&
        window.lindstromThemeContext &&
        window.lindstromThemeContext.bundleEnv === "admin"
    ) {
        return;
    }
    if (rootEl.dataset[CALCULATOR_INTERACTION_FLAG] === "1") {
        return;
    }
    rootEl.dataset[CALCULATOR_INTERACTION_FLAG] = "1";
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "calculator_interaction" });
};

const parseInputNum = ($root, selector) => {
    const el = $root.find(selector).get(0);
    if (!el) {
        return NaN;
    }
    const raw = String(el.value ?? "").trim();
    if (raw === "") {
        return NaN;
    }
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : NaN;
};

const bindBlock = ($root) => {
    if (typeof jQuery === "undefined") {
        return;
    }
    const $ = jQuery;

    const updateCalculator = () => {
        const emp = parseInputNum($root, ".paper-waste-calculator__input-employees");
        const busy = parseInputNum($root, ".paper-waste-calculator__input-busy");
        const work = parseInputNum($root, ".paper-waste-calculator__input-workdays");
        const sheetsFixed = parseInputNum($root, ".paper-waste-calculator__fixed-sheets");
        const weightG = parseInputNum($root, ".paper-waste-calculator__fixed-weight");

        let sum1 = NaN;
        let sum2 = NaN;
        let sum3 = NaN;
        let sum4 = NaN;

        const basicsOk =
            Number.isFinite(emp) &&
            Number.isFinite(busy) &&
            Number.isFinite(work) &&
            Number.isFinite(sheetsFixed);

        if (basicsOk) {
            sum1 = emp * (busy / 100) * work * sheetsFixed;
            sum3 = sum1 * 12;

            if (Number.isFinite(weightG)) {
                sum2 = (sum1 * weightG) / 1000;
                sum4 = sum2 * 12;
            }
        }

        const rootEl = $root.get(0);
        maybePushCalculatorInteractionOnce(rootEl, basicsOk && Number.isFinite(sum1));

        const $o1 = $root.find(".paper-waste-calculator__out-sum1");
        const $o2 = $root.find(".paper-waste-calculator__out-sum2");
        const $o3 = $root.find(".paper-waste-calculator__out-sum3");
        const $o4 = $root.find(".paper-waste-calculator__out-sum4");
        $o1.length && $o1.text(formatOut(sum1));
        $o2.length && $o2.text(formatOut(sum2));
        $o3.length && $o3.text(formatOut(sum3));
        $o4.length && $o4.text(formatOut(sum4));
    };

    $root.find(".calculator")
        .off("input.pwc", "input")
        .on("input.pwc", "input", function () {
            updateCalculator();
        });

    $root.find(".calculator .info em")
        .off("click.pwc")
        .on("click.pwc", function () {
            $root.find(".calculator .info ul").slideToggle(200);
            $root.find(".calculator .info em svg").toggleClass("rot");
        });

    $root.find(".calculator-results svg")
        .off("click.pwc")
        .on("click.pwc", function (e) {
            e.preventDefault();
            const $btn = $(this);
            const tooltip = $btn.parent().find("span.i-text");
            tooltip.fadeToggle(200);
            $root.find(".calculator .i-text").not(tooltip).fadeOut(200);
        });

    updateCalculator();
};

export const initPaperWasteCalculator = (blockWrapper) => {
    if (!blockWrapper || typeof jQuery === "undefined") {
        return;
    }
    bindBlock(jQuery(blockWrapper));
};

const setupPaperWasteCalculator = () => {
    if (typeof jQuery === "undefined") {
        return;
    }
    const blocks = document.querySelectorAll(".paper-waste-calculator");
    blocks.forEach((el) => initPaperWasteCalculator(el));
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupPaperWasteCalculator);
} else {
    setupPaperWasteCalculator();
}
